<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Airport Create",
      items: [
        {
          text: "Airport",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
      form: {
          city: "",
          airportCode: "",
          airportName: "",
          countryCode: "",
          country: "",
          worldAreaCode: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
        city: {
        required,
      },
        airportCode: {
        required,
      },
        airportName: {
            required,
        },
        countryCode: {
            required,
        },
        country: {
            required,
        },
        worldAreaCode: {
            required,
        },
    },
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/airport-create", {
            city:this.form.city,
            airportCode: this.form.airportCode,
            airportName: this.form.airportName,
            countryCode:this.form.countryCode,
            country: this.form.country,
            worldAreaCode: this.form.worldAreaCode,
            created_by: localStorage.getItem("uuid"),
            updated_by: localStorage.getItem("uuid"),
            accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.airportform.reset();
            this.$swal("Good job!", "Airport Added", "success");
            this.$router.push({ name: "airport_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="airportform" @submit.prevent="formSubmit">
              <div class="row">
                  <div class="col-md-6">
                      <div class="form-group">
                          <label class="required" for="city">City</label>
                          <input
                              id="city"
                              v-model="form.city"
                              name="city"
                              type="text"
                              class="form-control"
                              placeholder="Type city name"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.city.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.city.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.city.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label class="required" for="airportCode">Airport Code</label>
                          <input
                              id="airportCode"
                              v-model="form.airportCode"
                              name="airportCode"
                              type="text"
                              class="form-control"
                              placeholder="Type Airport Code"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.airportCode.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.airportCode.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.airportCode.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label class="required" for="airportName">Airport Name</label>
                          <input
                              id="airportName"
                              v-model="form.airportName"
                              name="airportName"
                              type="text"
                              class="form-control"
                              placeholder="Type Airport name"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.airportName.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.airportName.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.airportName.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label class="required" for="countryCode">Country Code</label>
                          <input
                              id="countryCode"
                              v-model="form.countryCode"
                              name="countryCode"
                              type="text"
                              class="form-control"
                              placeholder="Type Country Code"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.countryCode.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.countryCode.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.countryCode.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label class="required" for="country">Country</label>
                          <input
                              id="country"
                              v-model="form.country"
                              name="country"
                              type="text"
                              class="form-control"
                              placeholder="Type Country name"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.country.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.country.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.country.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label class="required" for="worldAreaCode">World Area Code</label>
                          <input
                              id="worldAreaCode"
                              v-model="form.worldAreaCode"
                              name="worldAreaCode"
                              type="text"
                              class="form-control"
                              placeholder="Type World area code"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.worldAreaCode.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.worldAreaCode.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.worldAreaCode.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
